import React, { useEffect, useRef, useState } from "react";
import { IoChevronDown } from "react-icons/io5";
import { Modal3 } from "../../../../components/DIsplay/Modal/Modal3";
import AssignRefund from "../../../../components/order/Refund/AssignRefund";
import TextInput from "../../../../components/form/TextInput";
import Button1 from "../../../../components/form/Button1";
import denyRefundRequest from "../../../../controllers/booking/postTicketing/refund/denyRefundRequest";
import { enqueueSnackbar } from "notistack";
import approveRefundTicket from "../../../../controllers/booking/postTicketing/refund/approveRefundTicket";
import checkRefundPrice from "../../../../controllers/booking/postTicketing/refund/checkRefundPrice";
import RefundQuote from "../../../../components/order/Refund/RefundQuote";
import submitRefund from "../../../../controllers/booking/postTicketing/refund/submitRefund";
import ManualRefund from "../../../../components/order/Refund/ManualRefund";

function RefundConfirmationManageOrder({ data }) {
  const [manageMenu, setManageMenu] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  const [modal, setModal] = useState({
    assign: false,
    accept: false,
    decline: false,
    quote: false,
    submission: false,
    reimburse: false,
  });
  const [loading, setLoading] = useState({
    accept: false,
    decline: false,
    autoQuote: false,
    submission: false,
  });
  const [rejectReason, setRejectReason] = useState(data?.rejectReason || "");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        manageMenu &&
        !menuRef.current?.contains(event.target) &&
        !buttonRef.current?.contains(event.target)
      ) {
        setManageMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [manageMenu]);

  const og = {
    ...data,
    flightBooking: [data?.flightBooking],
    flightObj: data?.flightBooking,
    type: "Flight",
  };

  // console.log({ data });

  const menuItems = [
    {
      label: "Assign Request",
      action: () => {
        setModal({ ...modal, assign: true });
      },
      visible: ["Pending", "Approved"].includes(data?.status),
    },
    {
      label: "Accept Request",
      action: () => {
        setModal({ ...modal, accept: true });
      },
      visible: ["Pending"].includes(data?.status),
    },
    {
      label: "Auto Quote",
      action: () => {
        handleRefreshRefundFee();
      },
      visible: ["Approved"].includes(data?.status) && !data?.confirmed,
    },
    {
      label: data?.passengerPrice?.length ? "Edit Quote" : "Create Quote",
      action: () => {
        setModal({ ...modal, quote: true });
      },
      visible: ["Approved"].includes(data?.status) && !data?.confirmed,
    },
    {
      label: "Confirm Airline Submission",
      action: () => {
        setModal({ ...modal, submission: true });
      },
      visible: ["Approved"].includes(data?.status) && data?.confirmed,
    },
    {
      label: "Re-imburse",
      action: () => {
        setModal({ ...modal, reimburse: true });
      },
      visible: ["PendingRefund"].includes(data?.status),
    },
    {
      label: "Decline Request",
      action: () => {
        setModal({ ...modal, decline: true });
      },
      visible: ["Pending", "Approved", "PendingRefund"].includes(data?.status),
    },
  ].filter((item) => item?.visible);

  // console.log({ data });

  if (!menuItems?.length) return <></>;

  async function handleRefreshRefundFee() {
    setLoading({ ...loading, autoQuote: true });
    const res = await checkRefundPrice(data?._id).finally(() =>
      setLoading({ ...loading, autoQuote: false })
    );
    if (res.return) {
      // enqueueSnackbar('Ticket has been issued.',{variant: 'success'})
      if (res?.data?.priceReceived) window.location.reload();
      else enqueueSnackbar("Refund Price not received", { variant: "warning" });
    } else enqueueSnackbar(res.msg, { variant: "error" });
  }

  async function handleDenyRefund() {
    const reqBody = {
      // ticketQueueId: _id,
      rejectReason,
    };
    setLoading({ ...loading, decline: true });
    const res = await denyRefundRequest(data?._id, reqBody).finally(() =>
      setLoading({ ...loading, decline: false })
    );

    if (res.return) {
      enqueueSnackbar("Refund request has been denied.", {
        variant: "success",
      });
      setTimeout(() => {
        window.location.reload();
      }, 300);
    } else enqueueSnackbar(res.msg, { variant: "error" });
  }

  async function handleApproveRefund() {
    setLoading({ ...loading, accept: true });
    const res = await approveRefundTicket(data?._id).finally(() =>
      setLoading({ ...loading, accept: false })
    );
    if (res.return) {
      enqueueSnackbar("Request has been approved.", { variant: "success" });
      setTimeout(() => {
        window.location.reload();
      }, 300);
    } else enqueueSnackbar(res.msg, { variant: "error" });
  }

  async function handleSubmitRefund() {
    setLoading({ ...loading, submission: true });
    const res = await submitRefund(data?._id).finally(() =>
      setLoading({ ...loading, submission: false })
    );
    if (res?.return) {
      enqueueSnackbar(res?.msg || "Refund submitted successfully", {
        variant: "success",
      });
      setTimeout(() => {
        window.location.reload();
      }, 300);
    } else
      enqueueSnackbar(res?.msg || "Failed to submit refund", {
        variant: "error",
      });
  }

  return (
    <div className="relative w-full lg:w-fit">
      <Modal3
        open={modal.reimburse}
        setOpen={(modalState) => setModal({ ...modal, reimburse: modalState })}
        title="Manual Refund"
      >
        <div className="p-4 max-w-[700px]">
          <ManualRefund callback={() => window.location.reload()} data={og} />
        </div>
      </Modal3>
      <Modal3
        open={modal.quote}
        setOpen={(modalState) => setModal({ ...modal, quote: modalState })}
        title={"Quote"}
      >
        <div className="p-4 max-w-[700px] md:min-w-[500px]">
          <RefundQuote data={og} reload={() => window.location.reload()} />
        </div>
      </Modal3>
      <Modal3
        open={modal.submission}
        setOpen={(modalState) => setModal({ ...modal, submission: modalState })}
        title={"Submit Refund Request"}
      >
        <div className="card p-4 flex flex-col gap-4 min-w-[300px]">
          <div className="py-4">
            Do you confirm you have requested refund to the airline?
          </div>
          <div className="flex justify-end items-center gap-4">
            <Button1
              variant="outlined"
              className="btn-outlined flex-1"
              onClick={() => setModal({ ...modal, submission: false })}
            >
              Close
            </Button1>
            <div>
              <Button1
                onClick={() => handleSubmitRefund()}
                loading={loading?.submission}
              >
                Continue
              </Button1>
            </div>
          </div>
        </div>
      </Modal3>
      <Modal3
        open={modal.assign}
        setOpen={(modalState) => setModal({ ...modal, assign: modalState })}
        title={"Assign Task"}
      >
        <div className="p-4 max-w-[700px]">
          <AssignRefund callback={() => window.location.reload()} data={og} />
        </div>
      </Modal3>
      <Modal3
        open={modal.accept}
        setOpen={(modalState) => setModal({ ...modal, accept: modalState })}
        title={"Accept Refund Request Task"}
      >
        <div className="max-w-[500px] p-4">
          <div className="p-4">
            <p>Are you sure you want to accept this refund request?</p>
          </div>
          <div className="flex gap-4">
            <Button1
              variant="text"
              onClick={() => setModal({ ...modal, accept: true })}
            >
              Cancel
            </Button1>
            <Button1
              loading={loading?.accept}
              onClick={() => handleApproveRefund()}
            >
              Accept Request
            </Button1>
          </div>
        </div>
      </Modal3>
      <Modal3
        open={modal.decline}
        setOpen={(modalState) => setModal({ ...modal, decline: modalState })}
        title={"Decline Refund Request"}
      >
        <div className="card p-4 flex flex-col  gap-4 min-w-[300px]">
          <h5>What's your reson?</h5>
          <TextInput
            label=""
            multiline
            rows={5}
            placeholder={"e.g. Ticket not available"}
            value={rejectReason || ""}
            onChange={(ev) => setRejectReason(ev.target.value)}
          />
          <div className="flex justify-end items-center gap-4">
            <Button1
              variant="outlined"
              className="btn-outlined flex-1"
              onClick={() => setModal({ ...modal, decline: false })}
            >
              Cancel
            </Button1>
            <div>
              <Button1
                onClick={() => handleDenyRefund()}
                loading={loading?.decline}
              >
                Continue
              </Button1>
            </div>
          </div>
        </div>
      </Modal3>
      {loading?.autoQuote ? (
        <div className="primaryLoader"></div>
      ) : (
        <button
          ref={buttonRef}
          onClick={() => setManageMenu((prev) => !prev)}
          className="border border-gray-300 h-12 rounded-md bg-gray-100 hover:bg-gray-200 transition-all w-full px-2 lg:px-4 flex items-center justify-center gap-2 text-sm font-semibold"
        >
          <span>Manage order</span>
          <IoChevronDown
            className={`text-base transition-transform mt-[2px] ${
              manageMenu ? "rotate-180" : ""
            }`}
          />
        </button>
      )}

      {manageMenu && (
        <div
          ref={menuRef}
          className="absolute right-0 mt-2 w-44 rounded-md border border-gray-200 bg-white shadow-lg overflow-hidden z-20"
        >
          {menuItems.map((itm, idx) => (
            <button
              key={idx}
              onClick={() => {
                setManageMenu(false);
                itm.action?.();
              }}
              className="w-full text-left px-3 py-2 text-sm hover:bg-gray-50"
            >
              {itm.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default RefundConfirmationManageOrder;
